import React, { useState, useEffect, useRef } from "react";

const AllergenIcon = ({ allergens, calories, showServingSize = true }) => {
    const [showAllergens, setShowAllergens] = useState(false);
    const containerRef = useRef(null);

    const toggleAllergens = () => {
        setShowAllergens(!showAllergens);
    };

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setShowAllergens(false);
            }
        };

        if (showAllergens) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showAllergens]);

    // Don't render if no allergens and no calories
    const hasCalories = calories && calories.min > 0 && calories.max > 0;
    if ((!allergens || allergens.length === 0) && !hasCalories) {
        return null;
    }

    return (
        <div className="allergenIconContainer" ref={containerRef}>
            <button
                className="allergenIcon"
                onClick={toggleAllergens}
                title="View nutritional info"
            >
                !
            </button>
            {showAllergens && (
                <div className="allergensList">
                    {hasCalories && (
                        <>
                            <p className="allergensTitle">
                                Calories{showServingSize && ' (16oz)'}
                            </p>
                            <p className="calorieInfo">{calories.min}-{calories.max} cal</p>
                        </>
                    )}
                    {allergens && allergens.length > 0 && (
                        <>
                            <p className="allergensTitle" style={{ marginTop: hasCalories ? '10px' : '0' }}>Allergens</p>
                            {allergens.map((allergen, index) => (
                                <span key={index} className="allergenTag">
                                    {allergen}
                                </span>
                            ))}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default AllergenIcon;

